import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import pages from './routes/pages'
import admin from './routes/admin'
import coordinador from './routes/coordinador'
import reports from './routes/reports'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        resource: 'Auth',
      },
    },
    ...apps,
    ...pages,
    ...admin,
    ...coordinador,
    ...reports,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()
  
  console.log('🔐 Router Guard:', {
    ruta: to.path,
    autenticado: isLoggedIn,
    requiereAuth: !to.meta.redirectIfLoggedIn
  })

  // Evitar redirección infinita - caso 1: misma ruta
  if (to.name === from.name) {
    return next()
  }

  // Evitar redirección infinita - caso 2: misma ruta con parámetros diferentes
  if (to.path === from.path) {
    return next()
  }

  // Lista de rutas públicas que NO requieren autenticación
  const publicPages = ['auth-login', 'auth-register', 'auth-forgot-password', 'error-404', 'misc-not-authorized']
  const authRequired = !publicPages.includes(to.name)

  // Si la ruta requiere autenticación y el usuario NO está logueado
  if (authRequired && !isLoggedIn) {
    console.warn('🚫 Ruta protegida sin autenticación - Redirigiendo a login')
    return next({ name: 'auth-login' })
  }

  // Verificar permisos de navegación usando CASL
  if (!canNavigate(to)) {
    if (!isLoggedIn) {
      console.warn('🚫 Sin permisos y sin autenticación - Redirigiendo a login')
      return next({ name: 'auth-login' })
    }
    console.warn('🚫 Sin permisos suficientes - Redirigiendo a not-authorized')
    return next({ name: 'misc-not-authorized' })
  }

  // Redirección para usuarios logueados que intentan acceder al login
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    const homeRoute = getHomeRouteForLoggedInUser(userData ? userData.role : null)
    
    console.log('↪️ Usuario logueado intentando acceder a login - Redirigiendo a home')
    
    // Evitar redirección si ya estamos en la ruta home
    if (to.name === 'home') {
      return next()
    }
    
    // Evitar redirección infinita si ya estamos en la ruta destino
    if (to.name === homeRoute.name) {
      return next()
    }
    
    next(homeRoute)
    return
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router